import {Component, OnInit} from '@angular/core';
import {UtilService} from '../../../../../core/services/util.service';
import {HttpClient} from '@angular/common/http';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { GoogleMapService } from '../../../../../core/services/google-map.service';
import { RestaurantStore } from 'src/app/core/stores/restaurant.store';
import { Restaurant } from 'src/app/core/models/restaurant.model';

@Component({
  selector: 'app-location-detecting-modal',
  templateUrl: './location-detecting-modal.component.html',
  styleUrls: ['./location-detecting-modal.component.scss'],
})
export class LocationDetectingModalComponent implements OnInit {
  public currentAddress: string;
  public center: google.maps.LatLngLiteral;
  public position: google.maps.LatLngLiteral = null;
  public isLoading: boolean;
  public restaurants: Restaurant[]

  constructor(
    private utilService: UtilService,
    private http: HttpClient,
    private matDialog: MatDialog,
    private googleMaps: GoogleMapService,
    private dialogRef: MatDialogRef<LocationDetectingModalComponent>,
    private restaurantStore: RestaurantStore
  ) { 
    this.restaurantStore.restaurants$.subscribe((restaurants: Restaurant[]) => {
        this.restaurants = restaurants;
    });
  }

  public get hasRestaurants(): boolean {
    return this.restaurants && this.restaurants.length > 0;
  }

  ngOnInit() {
    this.getCurrentLocation();
  }

  public closeModal(): void {
    this.dialogRef.close({
      position: this.position,
      address: this.currentAddress
    });
  }

  public clear(): void {
    this.currentAddress = null;
  }

  public findAddress() {
    this.isLoading = true;
    this.googleMaps.findAddress(this.currentAddress).subscribe(response => {
      if (response.results && response.results.length > 0) {
        this.isLoading = false;
        this.center = {
          lat: response.results[0].geometry.location.lat,
          lng: response.results[0].geometry.location.lng
        };
        this.position = this.center;
        this.closeModal();
      } else {
        this.isLoading = false;
        console.error('Geocoding failed');
      }
    });
  }

  public getCurrentLocation() {
    this.isLoading = true
    this.utilService.getCurrentLocation().subscribe(
      (position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.position = this.center;
        this.reverseGeocode(this.center);
        this.isLoading = false
      },
      (error) => {
        console.error('Ошибка получения местоположения:', error.message);
        this.isLoading = false
      }
    );
  }

  public reverseGeocode(latLng: google.maps.LatLngLiteral) {
    this.googleMaps.reverseGeocode(latLng).subscribe(response => {
      if (response.results && response.results.length > 0) {
        this.currentAddress = response.results[0].formatted_address;
      } else {
        console.error('Geocoding failed');
      }
    });
  }
}
